// Fichier généré par scripts/generate-csv-manifest.mjs — ne pas modifier à la main.
export const CSV_CATALOG = {
	"generatedAt": "2026-10-13T08:19:40.233Z",
	"defaultYear": 2026,
	"years": [
		2026,
		2025,
		2024,
		2023,
		2022,
		2021,
		2019,
		2018,
		2017,
		2016,
		2015,
		2014,
		2013,
		2012,
		2011,
		2010,
		2009,
		2008
	],
	"byYear": {
		"2008": {
			"teams": "/csv/Archive/New_resequipe2008.csv",
			"individuals": "/csv/Archive/New_resindiv2008.csv"
		},
		"2009": {
			"teams": "/csv/Archive/New_resequipe2009.csv",
			"individuals": "/csv/Archive/New_resindiv2009.csv"
		},
		"2010": {
			"teams": "/csv/Archive/New_resequipe2010.csv",
			"individuals": "/csv/Archive/New_resindiv2010.csv"
		},
		"2011": {
			"teams": "/csv/Archive/New_resequipe2011.csv",
			"individuals": "/csv/Archive/New_resindiv2011.csv"
		},
		"2012": {
			"teams": "/csv/Archive/New_resequipe2012.csv",
			"individuals": "/csv/Archive/New_resindiv2012.csv"
		},
		"2013": {
			"teams": "/csv/Archive/New_resequipe2013.csv",
			"individuals": "/csv/Archive/New_resindiv2013.csv"
		},
		"2014": {
			"teams": "/csv/Archive/New_resequipe2014.csv",
			"individuals": "/csv/Archive/New_resindiv2014.csv"
		},
		"2015": {
			"teams": "/csv/Archive/New_resequipe2015.csv",
			"individuals": "/csv/Archive/New_resindiv2015.csv"
		},
		"2016": {
			"teams": "/csv/Archive/New_resequipe2016.csv",
			"individuals": "/csv/Archive/New_resindiv2016.csv"
		},
		"2017": {
			"teams": "/csv/Archive/New_resequipe2017.csv",
			"individuals": "/csv/Archive/New_resindiv2017.csv"
		},
		"2018": {
			"teams": "/csv/Archive/New_resequipe2018.csv",
			"individuals": "/csv/Archive/New_resindiv2018.csv"
		},
		"2019": {
			"teams": "/csv/Archive/New_resequipe2019.csv",
			"individuals": "/csv/Archive/New_resindiv2019.csv"
		},
		"2021": {
			"teams": "/csv/Archive/New_resequipe2021.csv",
			"individuals": "/csv/Archive/New_resindiv2021.csv"
		},
		"2022": {
			"teams": "/csv/Archive/New_resequipe2022.csv",
			"individuals": "/csv/Archive/New_resindivi2022.csv"
		},
		"2023": {
			"teams": "/csv/Archive/New_Resequipes2023.CSV",
			"individuals": "/csv/Archive/New_resindivi2023.CSV"
		},
		"2024": {
			"teams": "/csv/Archive/New_Resequipes2024.CSV",
			"individuals": "/csv/Archive/New_Resindivi2024.CSV"
		},
		"2025": {
			"teams": "/csv/Archive/New_Resequipes2025.CSV",
			"individuals": "/csv/Archive/New_Resindivi2025.CSV"
		},
		"2026": {
			"teams": "/csv/New_Resequipes13102026.CSV",
			"individuals": "/csv/New_Resindividuels13102026.CSV"
		}
	}
};
